// src/components/Admin/Auth/ForgotPasswordForm.js
import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Auth } from '../../../../api/auth';
import { toast, ToastContainer } from 'react-toastify';
import { Link } from 'react-router-dom';
import './AuthForms.scss';
import { logoEduca } from '../../../../assets';   // tu logo

export function ForgotPasswordForm() {
  const [loading, setLoading] = useState(false);
  const authController = new Auth();

  const formik = useFormik({
    initialValues: { email: '' },
    validationSchema: Yup.object({
      email: Yup.string().email('Correo inválido').required('Requerido'),
    }),
    onSubmit: async ({ email }) => {
      try {
        setLoading(true);
        await authController.forgotPassword(email);
        toast.success('Si existe esa cuenta, recibirás un email.');
      } catch (err) {
        toast.error(err.message || 'Error al enviar el email');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Logo de Educa360 */}
        <img src={logoEduca.logoE360} alt="Educa360" className="auth-logo" />

        {/* El propio formulario */}
        <ToastContainer />
        <form className="auth-form" onSubmit={formik.handleSubmit}>
          <div className="input-group">
            <input
              name="email"
              type="email"
              placeholder="Correo electrónico"
              className="input-pill"
              value={formik.values.email}
              onChange={formik.handleChange}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="field-error">{formik.errors.email}</div>
            )}
          </div>
          <button type="submit" className="btn-pill" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar enlace'}
          </button>
        </form>

        {/* Link para volver al login */}
        <div className="auth-switch" style={{ marginTop: '1rem' }}>
          <Link to="/auth" className="link-btn">
            ← Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
